import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedCaracteristiqueTemplateService } from './caracteristique-template-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CaracteristiqueTemplateService extends GeneratedCaracteristiqueTemplateService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
